import React, { useEffect } from 'react';
import PhotoSwipeLightbox from 'photoswipe/lightbox';
import 'photoswipe/dist/photoswipe.css';

interface ImagePreviewProps {
  src: string;
  onClose: () => void;
}

const ImagePreview: React.FC<ImagePreviewProps> = ({ src, onClose }) => {
  const img = new Image();
  img.src = src;

  useEffect(() => {
    // 1. 初始化 PhotoSwipe
    const lightbox = new PhotoSwipeLightbox({
      pswpModule: () => import('photoswipe'),
      // 直接餵入圖片資料
      dataSource: [
        {
          src: src,
          width: img.width, // 使用真實寬度
          height: img.height, // 使用真實高度
        },
      ],
      // 介面設定
      showHideAnimationType: 'zoom',
      bgOpacity: 0.9,
    });

    lightbox.init();

    // 2. 立即開啟
    lightbox.loadAndOpen(0);

    // 3. 當 PhotoSwipe 關閉時，觸發父組件的 onClose 以卸載此組件
    lightbox.on('destroy', () => {
      onClose();
    });

    // 清除機制
    return () => {
      lightbox.destroy();
    };
  }, [src, onClose]);

  // PhotoSwipe 會自己產生 DOM 並掛載在 Body 下，所以這裡回傳空即可
  return null;
};

export default ImagePreview;